<script setup>
import { inject } from 'vue';

const field = inject('field', null);
</script>

<template>
    <small v-if="field.errors && field.errors.length" class="block text-rose dark:text-[#ff6969]/90 text-sm">
        {{ field.errors[0] }}
    </small>
</template>
